export default "__VITE_ASSET__O5N13C3N__"